import { Injectable } from '@angular/core';
import { Dashboard } from './dashboard.model'; // adjust path if needed

@Injectable({ providedIn: "root" })
export class DashboardService {
  dashboards: any[] = [];

  constructor() {
    try {
      if (typeof window !== "undefined") {
        const cached = localStorage.getItem("dashboards");
        if (cached) this.dashboards = JSON.parse(cached);
      }
    } catch (err) {
      console.log("LocalStorage not available or JSON error:", err);
    }
  }

  setDashboards(data: any[]) {
    this.dashboards = data;
  }

  getDashboardById(id: number): any | undefined {
    return this.dashboards.find((d) => d.id === id);
  }

  getAllDashboards(): any[] {
    return this.dashboards;
  }
}
